<template>
  <div class="page">
    <p class="p1">订单列表</p>
    <ul class="ul_1" v-for="(item,index) in orderList" :key="index">
      <li>
        <p>
          <span class="span1">订单状态：</span>
          <span class="soan2">已到账</span>
        </p>
        <p>
          <span class="span1">套餐名称：</span>
          <span class="soan2">{{item.productName}}</span>
        </p>
        <p>
          <span class="span1">订单价格：</span>
          <span class="soan2">¥{{item.price}}</span>
        </p>
        <p>
          <span class="span1">支付时间：</span>
          <span class="soan2">{{item.payTime.substr(0,16)}}</span>
        </p>
        <p>
          <span class="span1">订单编号：</span>
          <span class="soan2">{{item.orderNum}}</span>
        </p>
      </li>
    </ul>
  </div>
</template>
<script>
import { wx_order } from "@/api/api.js"; //获取微信订单
export default {
  data() {
    return {
      orderList:[]
    };
  },
  computed: {},
  methods: {
    // 获取订单
    initData(){
      let params ={
        iccid:this.$route.query.iccid,
        status:1
      }
      wx_order(params).then(res=>{
        if(res.data.code == 200){
          this.orderList = res.data.data;
        }
      })
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.document.title = "订单列表";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 16px;
    }
    .ul_1{
      padding: 0px 10px;
      box-sizing: border-box;
      
      li{
        margin-top: 10px;
        font-size: 13px;
        border-radius: 5px;
        padding: 0px 15px;
        border: 1px solid #F0F0F0;
        p{
          display: flex;
          justify-content: space-between;
          margin-top: 3px;
          span{
            margin: 0 10px 0 10px;
          }
          .soan2{
              color:#F94040;
          }
        }
      }
    }
  }

</style>

